(function () {
  var norm = function (s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); };

  function initDesktop(root) {
    if (root.dataset.ezmReady) return;
    root.dataset.ezmReady = '1';
    var tops = root.querySelectorAll('[data-ezm-open]');
    var panels = root.querySelectorAll('[data-ezm-panel]');
    var backdrop = null, timer = null;
    var header = root.closest('header-component, header, .header') || document.querySelector('header-component, header');
    // Move panels + backdrop to a layer on <body> so the header can't clip, cover or offset them
    var layer = document.createElement('div');
    layer.className = 'ezm-desktop ezm-layer';
    layer.setAttribute('style', root.getAttribute('style') || '');
    document.body.appendChild(layer);
    panels.forEach(function (p) { layer.appendChild(p); });

    function setTop() {
      var r = (header || root).getBoundingClientRect();
      document.documentElement.style.setProperty('--ezm-top', Math.max(0, Math.round(r.bottom)) + 'px');
    }
    function close() {
      clearTimeout(timer);
      tops.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      panels.forEach(function (p) { p.hidden = true; });
      if (backdrop) { backdrop.remove(); backdrop = null; }
    }
    function open(id) {
      clearTimeout(timer);
      setTop();
      tops.forEach(function (t) { t.setAttribute('aria-expanded', t.dataset.ezmOpen === id ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.dataset.ezmPanel !== id; });
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.className = 'ezm-backdrop';
        backdrop.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(close, 350); });
        backdrop.addEventListener('click', close);
        layer.insertBefore(backdrop, layer.firstChild);
      }
    }
    tops.forEach(function (t) {
      t.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        var isOpen = !!root.querySelector('[data-ezm-open][aria-expanded="true"]');
        timer = setTimeout(function () { open(t.dataset.ezmOpen); }, isOpen ? 220 : 90);
      });
      t.addEventListener('mouseleave', function () { clearTimeout(timer); if (t.getAttribute('aria-expanded') === 'true') timer = setTimeout(close, 400); });
      t.addEventListener('click', function () { t.getAttribute('aria-expanded') === 'true' ? close() : open(t.dataset.ezmOpen); });
    });
    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(timer); });
      p.addEventListener('mouseleave', function (e) {
        if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-ezm-open]')) return;
        clearTimeout(timer); timer = setTimeout(close, 400);
      });
    });
    root.querySelectorAll('a.ezm-top').forEach(function (a) { a.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(close, 250); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('scroll', function () { if (backdrop) setTop(); }, { passive: true });
    window.addEventListener('resize', close);

    panels.forEach(function (panel) {
      var q = panel.querySelector('[data-ezm-stone-q]');
      if (!q) return;
      var chips = panel.querySelectorAll('[data-ezm-letter]');
      var items = panel.querySelectorAll('.ezm-stonelist li');
      var L = '';
      function f() {
        var v = norm(q.value);
        items.forEach(function (li) { li.hidden = !((!L || li.dataset.l === L) && (!v || norm(li.dataset.n).indexOf(v) !== -1)); });
      }
      q.addEventListener('input', f);
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          L = c.dataset.ezmLetter;
          chips.forEach(function (x) { x.classList.toggle('is-on', x === c); });
          f();
        });
      });
    });
  }

  // Remove emoji and arrow decorations from menu text on phones (keeps the drawer calm)
  var EMOJI = /[←-⇿☀-➿️‍]|\uD83C[\uDDE6-\uDDFF]|[\uD83C-\uD83E][\uDC00-\uDFFF]/g;
  function stripEmoji(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) {
      var v = t.nodeValue.replace(EMOJI, '');
      if (v !== t.nodeValue) t.nodeValue = v.replace(/\s{2,}/g, ' ');
    });
  }
  function pm() { var s = document.createElement('span'); s.className = 'ezm-pm'; s.setAttribute('aria-hidden', 'true'); return s; }

  function initMobile(root) {
    if (root.dataset.ezmReady) return;
    root.dataset.ezmReady = '1';
    var drawer = root.querySelector('[data-ezm-drawer]');
    var openBtn = root.querySelector('[data-ezm-drawer-open]');
    if (!drawer || !openBtn) return;
    // Move drawer to <body> so the header's stacking/overflow can't clip it
    drawer.style.cssText += ';' + (root.getAttribute('style') || '');
    document.body.appendChild(drawer);

    // Visible "Menü / Menu" label next to the burger icon (bigger, clearer tap target)
    if (!openBtn.querySelector('.ezm-burger__t')) {
      var lab = document.createElement('span');
      lab.className = 'ezm-burger__t';
      lab.textContent = openBtn.getAttribute('aria-label') || 'Menu';
      lab.setAttribute('aria-hidden', 'true');
      openBtn.appendChild(lab);
    }

    var body = drawer.querySelector('.ezm-drawer__body');

    // Search: quiet underlined field at the top of the list
    var form = drawer.querySelector('.ezm-drawer__search');
    if (form && body) {
      form.className = 'ezm-m-search';
      form.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>');
      body.insertBefore(form, body.firstChild);
    }

    stripEmoji(drawer);

    // Turn "go to level" rows into inline accordions
    var rows = drawer.querySelectorAll('[data-ezm-go]');
    rows.forEach(function (b) {
      var lvl = drawer.querySelector('[data-ezm-level="' + b.dataset.ezmGo + '"]');
      if (!lvl) return;
      var id = 'ezm-lv-' + b.dataset.ezmGo + '-' + Math.random().toString(36).slice(2, 7);
      lvl.id = id;
      b.setAttribute('aria-expanded', 'false');
      b.setAttribute('aria-controls', id);
      b.appendChild(pm());
      b.parentElement.appendChild(lvl);
    });
    drawer.querySelectorAll('.ezm-acc').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.appendChild(pm());
    });

    // Smooth height animation for opening/closing parts of the menu
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function done(el, fn) {
      var t = setTimeout(fin, 480);
      function fin(e) { if (e && e.target !== el) return; clearTimeout(t); el.removeEventListener('transitionend', fin); fn(); }
      el.addEventListener('transitionend', fin);
    }
    function expand(el) {
      el.hidden = false;
      if (reduce) return;
      el.classList.add('ezm-anim');
      el.style.height = '0px'; el.style.opacity = '0';
      void el.offsetHeight;
      el.style.height = el.scrollHeight + 'px'; el.style.opacity = '1';
      done(el, function () { el.style.height = ''; el.style.opacity = ''; el.classList.remove('ezm-anim'); });
    }
    function shrink(el, after) {
      if (reduce || el.hidden) { el.hidden = true; if (after) after(); return; }
      el.classList.add('ezm-anim');
      el.style.height = el.scrollHeight + 'px';
      void el.offsetHeight;
      el.style.height = '0px'; el.style.opacity = '0';
      done(el, function () { el.hidden = true; el.style.height = ''; el.style.opacity = ''; el.classList.remove('ezm-anim'); if (after) after(); });
    }

    function collapse(except, instant) {
      rows.forEach(function (b) {
        if (b === except) return;
        var was = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', 'false');
        var l = document.getElementById(b.getAttribute('aria-controls'));
        if (!l) return;
        if (instant || !was) l.hidden = true; else shrink(l);
      });
    }
    rows.forEach(function (b) {
      b.addEventListener('click', function () {
        var l = document.getElementById(b.getAttribute('aria-controls'));
        if (!l) return;
        var open = b.getAttribute('aria-expanded') === 'true';
        collapse(b);
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) shrink(l); else expand(l);
      });
    });

    // Sub-groups (details) open and close smoothly too
    drawer.querySelectorAll('.ezm-acc').forEach(function (d) {
      var s = d.querySelector('summary'), list = d.querySelector('ul');
      if (!s || !list) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) { shrink(list, function () { d.open = false; list.hidden = false; }); }
        else { d.open = true; expand(list); }
      });
    });

    // Staggered entrance of the rows
    drawer.querySelectorAll('.ezm-rows > li').forEach(function (li, i) { li.style.setProperty('--i', Math.min(i, 10)); });

    var closeTimer = null;
    function closeAll() {
      openBtn.setAttribute('aria-expanded', 'false');
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { drawer.hidden = true; collapse(null, true); }, reduce ? 0 : 480);
      openBtn.focus();
    }
    openBtn.addEventListener('click', function () {
      clearTimeout(closeTimer);
      drawer.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      void drawer.offsetWidth;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      var first = drawer.querySelector('.ezm-drawer__close');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
    });
    drawer.querySelectorAll('[data-ezm-drawer-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    drawer.querySelectorAll('[data-ezm-stone-q]').forEach(function (q) {
      var list = q.parentElement.querySelectorAll('.ezm-m-stones li');
      q.addEventListener('input', function () {
        var v = norm(q.value);
        list.forEach(function (li) { li.hidden = v && norm(li.dataset.n).indexOf(v) === -1; });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ezm-desktop]:not(.ezm-layer)').forEach(initDesktop);
    document.querySelectorAll('[data-ezm-mobile]').forEach(initMobile);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
